import { inject, Injectable, OnDestroy } from '@angular/core'; 
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { map, distinctUntilChanged, takeUntil } from 'rxjs';
import { MobileOptimisationWarningComponent } from '../components/mobile-optimisation-warning/mobile-optimisation-warning.component';

@Injectable({
  providedIn: 'root'
})
export class MobileWarningService implements OnDestroy {
  private matDialog = inject(MatDialog);
  private breakpointObserver = inject(BreakpointObserver);
  private readonly MOBILE_MESSAGE_SEEN_KEY = 'sidoGlobalMobileMessageSeen';
  private destroy$ = new Subject<void>();

  constructor() {}

  public checkAndShowMobileWarning(): void {
    if (sessionStorage.getItem(this.MOBILE_MESSAGE_SEEN_KEY)) {
      return;
    }

    this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.TabletPortrait
    ]).pipe(
      map(result => result.matches),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(isMobile => {
      if (isMobile && !sessionStorage.getItem(this.MOBILE_MESSAGE_SEEN_KEY)) {
        this.openWarningDialog();
      }
    });
  }

  private openWarningDialog(): void {
    const dialogRef = this.matDialog.open(MobileOptimisationWarningComponent, {
      disableClose: true,
      autoFocus: 'dialog'
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(() => {
      sessionStorage.setItem(this.MOBILE_MESSAGE_SEEN_KEY, 'true');
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}